import { FlowService } from '../../service/FlowService';
import { normalizeReferenceKeysInNodes } from './referenceTokens';

// Shared flow-load step: rewrite legacy {{label.field}} tokens to the stable
// {{<refKey>.field}} form (unique labels only) and persist when anything changed.
// Called by EVERY flow-editor loader (CoreNodeDisplay, CoreNodeDisplaySpaces) so
// the migration is never missed for one view. Returns the nodes to render.
export function normalizeReferencesOnLoad<T>(nodes: T[], flowId?: string): T[] {
  const { nodes: normalized, rewrites } = normalizeReferenceKeysInNodes(
    nodes as any,
  );
  if (rewrites > 0 && flowId) {
    FlowService.updateFlow(flowId, { nodes: normalized }).catch(error =>
      console.error('Failed to persist reference normalization', {
        flowId,
        error: error instanceof Error ? error.message : 'Unknown error',
      }),
    );
    return normalized as T[];
  }
  return nodes;
}
